import { SharedModule } from '../../shared/shared.module';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SearchBarComponent } from '../../shared/search-bar/search-bar.component';
import { CourseCardComponent } from '../../shared/course-card/course-card.component';
import { CourseCardType } from '../../enums/courseCardType.enum';
import { User } from '../../models/user';
import { PublishStatusEnum } from '../../enums/publishStatus.enum';
import { MatChipsModule } from '@angular/material/chips';
import { AuthService } from '../../services/auth/auth.service';
import { PagingComponent } from "../../shared/paging/paging.component";
import { Project } from '../../models/project';
import { FavoriteTypeEnum } from '../../enums/favoriteType.enum';
import { Favorite } from '../../models/favorite';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { cloneDeep } from 'lodash';
import { IFilter } from '../../models/filter';
import { PagingQueryOptions } from '../../models/pagingQueryOptions ';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { isNoEmptyArray } from '@pineapplelab/util';

enum TabIndex {
	COURSES = 0,
	CHAPTERS = 1,
}
@Component({
	selector: 'app-favorites',
	standalone: true,
	templateUrl: './favorites.component.html',
	styleUrl: './favorites.component.scss',
	imports: [
		SharedModule,
		SearchBarComponent,
		CourseCardComponent,
		MatChipsModule,
		MatTabsModule,
		NgxSkeletonLoaderModule
	]
})
export class FavoritesComponent implements OnInit {

	placeholder: string = 'general.search'
	projectId = this.authService.projectId;
	cardTypes = CourseCardType;
	listOrTable: boolean = true;
	listView: boolean = false;
	model: User;
	publishStatusEnum = PublishStatusEnum;
	listUsers: User[] = [];
	favorites: Favorite[] = [];
	pagingData: any[] = [];
	data: any[] = []
	loading: boolean = true;
	FavoriteTypeEnum = FavoriteTypeEnum;
	activeTab: FavoriteTypeEnum = FavoriteTypeEnum.COURSE;
	filters: IFilter[] = [
		{ property: 'type', value: FavoriteTypeEnum.COURSE, isArray: false },
		{ property: 'is_deleted', value: false, isArray: false },
	];

	@ViewChild(PagingComponent) pagingComponent: PagingComponent;

	queryOptions: PagingQueryOptions;
	selectedTab: FavoriteTypeEnum = FavoriteTypeEnum.COURSE;
	isThereData: boolean = false;

	constructor(
		private authService: AuthService
	) { }

	ngOnInit(): void {
		this.queryOptions = {
			path: `${Project.PATH}/${this.authService.projectId}/${User.PATH}/${this.authService.auth.user.id}/${Favorite.PATH}`,
			pageSize: 8,
			orderBy: 'course_name_lowercase',
			orderDirection: 'asc',
			filters: this.filters,
		}
	}

	getPagingData(data: any) {
		this.setLoading(true);
		this.favorites = data.map((favorite: any) => new Favorite(favorite));
		if (isNoEmptyArray(this.favorites) && !this.queryOptions?.searchText && this.pagingData && this.pagingComponent?.currentPage == 1) {
			this.isThereData = true;
		}
		if (!this.pagingData.length) {
			this.pagingData = cloneDeep(this.favorites);
		}
		this.setLoading(false);
	}

	private setFiltersForTab(tabType: FavoriteTypeEnum, orderBy: string, searchString: string) {
		this.updateQueryOptions({
			filters: [
				{ property: 'type', value: tabType, isArray: false },
				{ property: 'is_deleted', value: false, isArray: false }
			],
			orderBy,
			refreshPage: true,
			searchText: searchString ?? this.queryOptions?.searchText
		});
	}

	async onTabChanged(event: MatTabChangeEvent) {
		this.setLoading(true);
		this.queryOptions.searchText = '';
	}

	async handleActionSearch(searchText: string) {
		this.updateQueryOptions({ searchText });
	}

	private updateQueryOptions(newOptions: Partial<typeof this.queryOptions>): void {
		this.queryOptions = {
			...this.queryOptions,
			...newOptions
		};
	}

	async switchingTabs(): Promise<void> {
		this.favorites = [];
		if (this.selectedTab === 0) {
			this.setFiltersForTab(FavoriteTypeEnum.COURSE, 'course_name_lowercase', '');
		} else if (this.selectedTab === 1) {
			this.setFiltersForTab(FavoriteTypeEnum.CHAPTER, 'chapter_name_lowercase', '');
		}
	}

	async updateView(ev: boolean) {
		await this.pagingComponent.loadFirstPage();
		this.isThereData = isNoEmptyArray(this.favorites) && !this.queryOptions?.searchText && this.pagingData && this.pagingComponent?.currentPage === 1;
	}

	setLoading(value: boolean): void {
		this.loading = value;
	}

}
